import { get, patch } from './baseApi';

export const PreferenceApi = {
    fetch: (options = {}) => get('/preferences', options),
    patch: (data, options = {}) => patch('/preferences', data, options),
};
